export class Changelog {
  id: number;
  recordVersionNr: number;
  creationDateTime: Date;
  user: string;
  message: string;
}



// WEBPACK FOOTER //
// ./src/app/models/changelog.model.ts